import {Component, HostListener, OnInit} from '@angular/core';
import {CustomerModel} from "../../order-to-cash/models-otc/customer-model";
import {MatTableDataSource} from "@angular/material/table";
import {PageEvent} from "@angular/material/paginator";
import {MatDialog} from "@angular/material/dialog";
import {Router} from "@angular/router";
import {RecommendationManagerService} from '../recommendation-manager.service';
import {CustomerService} from '../../order-to-cash/services-otc/customer.service';
import {NavBarComponent} from '../../nav-bar/nav-bar.component';
import {RecommendationManagerSharedDataService} from '../recommendation-manager-shared-data.service';
import {FilterDialogComponent} from '../dialogs/filter-dialog/filter-dialog.component';
import dayjs from 'dayjs';

@Component({
    selector: 'app-recommendations',
    templateUrl: './recommendations.component.html',
    styleUrls: ['./recommendations.component.css'],
    standalone: false
})
export class RecommendationsComponent implements OnInit {

  currentPage: number = 0;
  customerList: CustomerModel[] = [];
  dataSource = new MatTableDataSource();

  pageSize: number = 25;
  startDate: string = '';
  endDate: string = '';
  searchText: string = '';
  timerInterval: any;
  selectedClientId: number = 0;
  tableColumns = ['recommendationId', 'client', 'dateCreated', 'createdBy', 'dateComplete', 'status', 'type', 'actions'];
  tableHeight: string = (window.innerHeight - 280) + 'px';
  totalElements: number = 0;
  isFilterBtnVisible: boolean = false;
  recManTypes: {id: number, name: string}[] = [];
  selectedRecManTypeId: number = null;

  constructor(
      private router: Router,
      private recommendationManagerService: RecommendationManagerService,
      private customerService: CustomerService,
      private nav: NavBarComponent,
      private recommendationManagerSharedDataService: RecommendationManagerSharedDataService,
      private dialog: MatDialog
  ) {
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.tableHeight = (window.innerHeight - 280) + 'px';
  }

  ngOnInit(): void {
    this.nav.toggleLoading(true);
    this.getRecommendationList();
    this.getCustomerList();
    this.loadRecManTypes();
  }

  loadRecManTypes(): void {
    this.recommendationManagerService.getRecManTypes(0).subscribe({
        next: (res) => { this.recManTypes = res.map(t => ({ id: t.id, name: t.description })); }
      });
  }

  getCustomerList() {
    this.customerService.getCustomerDetails().subscribe({
      next: res => {
        this.customerList = res;

        this.recommendationManagerSharedDataService.updateCustomerDetails(res);
      }
    })
  }

  searchRecommendations() {
    if(this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    this.timerInterval = setInterval(() => {
      this.isFilterBtnVisible = true;
      this.getRecommendationList();
    }, 800);
  }

  getRecommendationList() {
    if(this.timerInterval) {
      clearInterval(this.timerInterval);
    }

    this.nav.toggleLoading(true)
    this.recommendationManagerService.getRecommendationList(this.currentPage, this.pageSize, this.startDate, this.endDate, this.searchText, this.selectedClientId, this.selectedRecManTypeId).subscribe({
      next: (res) => {
        this.dataSource = new MatTableDataSource(res.content);
        this.totalElements = res.totalElements;
        this.nav.toggleLoading(false);
      },
      error: (err) => {
        this.nav.toggleLoading(false);
      }
    });
  }

  onPaginateChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getRecommendationList();
  }

  routeToRecommendation(recommendationId: number, recManTypes?: any, recommendationNote?: string) {
    const desc = recManTypes?.description?.toLowerCase() || '';
    
    // Check for Soil Crop Nutrition (via type or note fallback)
    if (desc.includes("crop nutrition") || 
        (!recManTypes && recommendationNote?.toLowerCase().includes("crop nutrition"))) {
      this.router.navigateByUrl('soil-crop-nutrition/' + recommendationId);
      return;
    }
    
    if (recManTypes?.pinTypes?.name === "Soil") {
      const route = desc.includes("maintenance") ? "soil-maintenance" : "soil-preparation";
      this.router.navigateByUrl(route + "/" + recommendationId);
      return;
    }
    this.router.navigateByUrl('recommendation-manager/details/'+recommendationId);
  }

  clearFilters() {
    this.selectedClientId = -1;
    this.selectedRecManTypeId = -1;
    this.startDate = '';
    this.endDate = '';
    this.searchText = '';
    this.isFilterBtnVisible = false;
    this.getRecommendationList();
  }

  openFilterDialog() {
    const dialogRef = this.dialog.open(FilterDialogComponent,
        {
          data: {
            customerList: this.customerList,
            selectedClientId: this.selectedClientId,
            startDate: this.startDate,
            endDate: this.endDate,
            recManTypes: this.recManTypes
          },
          width: '400px'
        }
        );

    dialogRef.afterClosed().subscribe({
      next: res => {
        if(res) {
          if(res.selectedClientId) {
            this.isFilterBtnVisible = true;
            this.selectedClientId = res.selectedClientId;
          }

          if(res.selectedRecManTypeId) {
            this.isFilterBtnVisible = true;
            this.selectedRecManTypeId = res.selectedRecManTypeId;
          }

          if(res.startDate && res.endDate) {
            this.isFilterBtnVisible = true;
            this.startDate = dayjs(res.startDate).format('YYYY-MM-DD')
            this.endDate = dayjs(res.endDate).format('YYYY-MM-DD')
          }

          this.getRecommendationList();
        }
      }
    })
  }

  showPageSizeMenu: boolean = false;

  goToPage(page: number) {
    this.currentPage = page;
    this.getRecommendationList();
  }

  onPageSizeChange(size: number) {
    this.pageSize = size;
    this.currentPage = 0;
    this.showPageSizeMenu = false;
    this.getRecommendationList();
  }

  get lastPage(): number {
    return Math.max(0, Math.ceil(this.totalElements / this.pageSize) - 1);
  }

  min(a: number, b: number): number {
    return Math.min(a, b);
  }
}
